var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex justify-content-center align-items-center w-100 h-100 font-large-2"},[_vm._v(" You can! ")])}
var staticRenderFns = []

export { render, staticRenderFns }